import React from 'react';
import styles from './AdminMobileRegisterBtn.module.css';
import { useNavigate } from 'react-router-dom';

const AdminMobileRegisterBtn = ({to}) => {
    let navigate = useNavigate();

    const handleClick = () => {
        navigate(to); // props로 받은 경로로 이동
    }

    return (
        <div className={styles.moveBtn} onClick={handleClick}>
            <span>+</span>
        </div>
    );
};

export default AdminMobileRegisterBtn;